// TODO: remove ts-nocheck and fix warnings and errors on this file
// @ts-nocheck
import Link from 'next/link';
import BlockContent from '@sanity/block-content-to-react';
import { ExternalLinkIcon } from '@components';
import { Box } from '@chakra-ui/react';
import { tableStyle } from './table-style';

const types = {
  block: props => {
    return BlockContent.defaultSerializers.types.block(props);
  }
};

const marks = {
  fragmentId: ({ mark, children }) => {
    const { hash } = mark;
    return <span id={hash}>{children}</span>;
  },
  internalLink: ({ mark, children }) => {
    const { hash, slug = {} } = mark;
    const href = slug?.current;

    if (hash) {
      return <a href={`${href || ''}#${hash}`}>{children}</a>;
    }

    if (href) {
      return (
        <Link legacyBehavior href={href}>
          <a className="font-normal">{children}</a>
        </Link>
      );
    }

    return <span>{children}</span>;
  },
  link: ({ mark, children }) => {
    const { blank, href } = mark;

    if (href) {
      return blank ? (
        <a href={href} target="_blank" rel="noopener" className="font-normal">
          {children}
          <ExternalLinkIcon className="relative top-[-2px] ml-1 inline-block" />
        </a>
      ) : (
        <a href={href} className="font-normal">
          {children}
        </a>
      );
    }
    return <span>{children}</span>;
  }
};

const serializers = {
  types,
  marks
};

export function PropsTable({ props }) {
  const hasName = props.some(prop => prop.name);
  const hasType = props.some(prop => prop.type);
  const hasDescription = props.some(prop => prop.description);

  return (
    <Box
      className="flex flex-col"
      sx={{
        '&': tableStyle
      }}
    >
      <div className="inline-block max-w-full overflow-auto py-2">
        <table className="divide-y divide-gray-300 shadow ">
          <thead className="bg-gray-50">
            <tr>
              {hasName && (
                <th
                  scope="col"
                  className="w-1/4 py-2 !px-4 text-sm font-semibold text-gray-900"
                >
                  Name
                </th>
              )}

              {hasType && (
                <th
                  scope="col"
                  className="w-1/4 py-2 !px-4 text-sm font-semibold text-gray-900"
                >
                  Type
                </th>
              )}
              {hasDescription && (
                <th
                  scope="col"
                  className="w-1/2 py-2 !px-4 text-sm font-semibold text-gray-900"
                >
                  Description
                </th>
              )}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white ">
            {props.map((prop, index) => {
              const { description } = prop;
              return (
                <tr key={index}>
                  {hasName && (
                    <td className="w-1/4 border-r py-2 !px-4 text-sm font-medium text-gray-900 ">
                      {prop.name}
                    </td>
                  )}
                  {hasType && (
                    <td className="w-1/4 border-r py-2 !px-4 italic text-gray-700">
                      {prop.type}
                    </td>
                  )}
                  {hasDescription && (
                    <td className="font-base w-1/2 border-r py-2 !px-4 text-sm text-gray-800 ">
                      <BlockContent
                        blocks={description}
                        serializers={serializers}
                      />
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Box>
  );
}
